/* eslint-disable */
import React, { useState } from "react";
import Body from "./Body";

const Dashboard = () => {
  const [lineChartData, setLineChartData] = useState([
    {
      name: "Jan",
      fees: 4000,
    },
    {
      name: "Feb",
      fees: 3000,
    },
    {
      name: "Mar",
      fees: 2000,
    },
    {
      name: "Apr",
      fees: 2780,
    },
    {
      name: "May",
      fees: 1890,
    },
    {
      name: "Jun",
      fees: 2390,
    },
    {
      name: "Jul",
      fees: 3490,
    },
    {
      name: "Aug",
      fees: 2000,
    },
    {
      name: "Sept",
      fees: 2780,
    },
    {
      name: "Oct",
      fees: 1890,
    },
    {
      name: "Nov",
      fees: 2390,
    },
    {
      name: "Dec",
      fees: 3490,
    },
  ]);
  const [donutChartData, setDonutChartData] = useState([
    {
      categories: "Payments",
      contribution: 28.6,
      positionColor: "rgba(20, 184, 166, 0.56)",
    },
    {
      categories: "Dividents",
      contribution: 42.9,
      positionColor: "rgba(59, 130, 246, 0.56)",
    },
    {
      categories: "Educational materials",
      contribution: 28.6,
      positionColor: "rgba(99, 102, 241, 0.56)",
    },
    {
      categories: "Office supplies",
      contribution: 28.6,
      positionColor: "rgba(236, 72, 153, 0.56)",
    },
    {
      categories: "Electricity",
      contribution: 14.3,
      positionColor: "rgba(245, 158, 11, 0.56)",
    },
    {
      categories: "Activities",
      contribution: 14.3,
      positionColor: "rgba(250, 204, 21, 0.56)",
    },
  ]);
  const [grants, setGrants] = useState([
    { name: "Jan", grants: 4000 },
    { name: "Feb", grants: 3000 },
    { name: "Mar", grants: 2000 },
    { name: "Apr", grants: 2780 },
    { name: "May", grants: 1890 },
    { name: "Jun", grants: 2390 },
    { name: "Jul", grants: 3490 },
    { name: "Aug", grants: 2000 },
    { name: "Sept", grants: 2780 },
    { name: "Oct", grants: 1890 },
    { name: "Nov", grants: 2390 },
    { name: "Dec", grants: 3490 },
  ]);
  const [othersList, setOthersList] = useState([
    {
      name: "Toufik Alam",
      gid: "23456789",
      contact: "9876543210",
      date: "02 Oct, 2025",
      grants: "60 bosta cement",
    },
    {
      name: "Mustak Ahamed",
      gid: "23456789",
      contact: "9876543210",
      date: "02 Oct, 2025",
      grants: "30 Students school uniform stitching cost",
    },
    {
      name: "Anisur Islam",
      gid: "23456789",
      contact: "9876543210",
      date: "02 Oct, 2025",
      grants: "60 bosta cement",
    },
    {
      name: "Rohit Khan",
      gid: "23456789",
      contact: "9876543210",
      date: "02 Oct, 2025",
      grants: "60 bosta cement",
    },
    {
      name: "Toufik Alam",
      gid: "23456789",
      contact: "9876543210",
      date: "02 Oct, 2025",
      grants: "60 bosta cement",
    },
    {
      name: "Toufik Alam",
      gid: "23456789",
      contact: "9876543210",
      date: "02 Oct, 2025",
      grants: "60 bosta cement",
    },
    {
      name: "Mustak Ahamed",
      gid: "23456789",
      contact: "9876543210",
      date: "02 Oct, 2025",
      grants: "30 Students school uniform stitching cost",
    },
    {
      name: "Anisur Islam",
      gid: "23456789",
      contact: "9876543210",
      date: "02 Oct, 2025",
      grants: "60 bosta cement",
    },
    {
      name: "Rohit Khan",
      gid: "23456789",
      contact: "9876543210",
      date: "02 Oct, 2025",
      grants: "60 bosta cement",
    },
    {
      name: "Toufik Alam",
      gid: "23456789",
      contact: "9876543210",
      date: "02 Oct, 2025",
      grants: "60 bosta cement",
    },
    // Additional rows can be added here
  ]);
  const _this = { lineChartData, donutChartData, grants, othersList };
  return <Body {..._this} />;
};

export default Dashboard;
